//ENV VARS
let vivus;
const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const days = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'];

jQuery(document).ready(function($){
	// HEADER
	// fixed header
	let win = $(window);
	let winW = win.width();

	win.on('scroll', function() {
		if ($(this).scrollTop() > 100) {
			$('.top-bar').addClass('active');
		} else {
			$('.top-bar').removeClass('active');
		}
	});

	// show menu
	$('.menu-trigger').on('click', function(e) {
		e.preventDefault();
		$('#menu-overlay').slideToggle();
	});

	// BLOCKS
	// hero slider block
	if ($('.hero-slider-block').length) {
		var slider = tns({
			container: '#hero-slider',
			mode: 'gallery',
			items: 1,
			controls: false,
			nav: false,
			slideBy: 1,
			autoplay: true,
			loop: true,
			autoplayButtonOutput: false
		});

		$('.hero-slider-block .icons li').on('mouseover', function() {
			let id = $(this).attr('data-content');
			$('#icon-text-spacer').hide();
			$('.icon-subtitle').hide();
			$('#' + id).show();
		});

		$('.hero-slider-block .icons li').on('mouseout', function() {
			$('#icon-text-spacer').show();
			$('.icon-subtitle').hide();
		});
	}

	// services block
	if ($('.services-block').length && winW < 1024) {
		var slider = tns({
			container: '.services-container',
			items: 1,
			controls: false,
			slideBy: 1,
			autoplay: true,
			center: true,
			loop: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			responsive: {
				'1024': {
					disable: true
				}
			}
		});
	}

	// testimonial block
	if ($('.testimonial-block').length) {
		var slider = tns({
			container: '#testimonial-slider',
			items: 1,
			gutter: 30,
			controls: false,
			slideBy: 1,
			autoplay: true,
			center: true,
			loop: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			responsive: {
				'1024': {
					items: 3
				}
			}
		});
	}

	// tabs block
	if($('.tabs-block').length) {
		$('.tabs-select').on('change', function(e) {
			let id = $('option:selected', this).attr('data-tab');

			$(this).closest('.tabs-block').find('.tab-content').hide();
			$(this).closest('.tabs-block').find('.tab-content[data-content="' + id + '"]').show();
		});

		$('.tabs-container .button').on('click', function(e) {
			let id = $(this).attr('data-tab');

			e.preventDefault();
			$(this).toggleClass('active');
			$(this).closest('.tabs-block').find('.tab-content').hide();
			$(this).closest('.tabs-block').find('.tab-content[data-content="' + id + '"]').show();
		});

		$('.accordion-container .title').on('click', function() {
			$(this).toggleClass('active');
			$(this).parent().find('.content').slideToggle();
		});
	}

	// text image button block
	if ($('.tib-block').length) {
		$('.tib-block a').on('click', function(e) {
			e.preventDefault();
			$(this).parent().find('.extra').slideToggle();
		});
	}

	// curve text button block
	if ($('.ctb-block').length) {
		$('.gradient-bg').addClass('ctb');
		$('footer').addClass('ctb');
	}

	// referral form block
	if ($('.referral-form-block').length) {
		registerModalControls();
	}

	// RESPONSIVE
	// icon highlight block
	if ($('.icon-highlight-block').length) {
		var slider = tns({
			container: '.icon-highlight-block .icons-container',
			items: 1,
			controls: false,
			slideBy: 1,
			autoplay: true,
			center: true,
			loop: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			responsive: {
				'1024': {
					disable: true
				}
			}
		});
	}

	// LOGIN MODAL
	$('.mybigodes-enter').on('click', function(e) {
		e.preventDefault();
		$('#login-modal').foundation('open');
	});

	// PASSWORD RECOVERY MODAL
	$('#password-reset').on('click', function(e) {
		e.preventDefault();
		$('#recover-password-modal').foundation('open');
	});

	// REGISTER MODAL
	$('#register-modal-open').on('click', function(e){
		e.preventDefault();
		resetRegisterForm();
		registerModalControls();
	});

	// LOGIN
	$('#customer-login').on('submit', function(e){
		loadingStatus();
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()) {
			let form_data = $(this).serializeArray();
			let form_status = $(this).find('.form-message');

			$.ajax({
				type: data.rest.endpoints.customer_login.method,
				dataType: 'json',
				url: data.rest.endpoints.customer_login.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				if (results.loggedin == true){
					document.location.href = data.rest.endpoints.customer_login.redirect;
				} else {
					loadingStatus();
					form_status.addClass('error');
					form_status.html(data.rest.messages.wrongdata);
				}
			}).fail(function(xhr){
				console.log(xhr);
			});
		}
	});

	// PASSWORD RECOVERY
	$('#password-recover').on('submit', function(e){
		loadingStatus();
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			let form_data = $(this).serializeArray();
			let form_status = $(this).find('.form-message');

			$.ajax({
				type: data.rest.endpoints.password_recovery.method,
				dataType: 'json',
				url: data.rest.endpoints.password_recovery.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				loadingStatus();
				if (results.user == true){
					successModal(data.rest.messages.recovered);
				} else {
					form_status.html(data.rest.messages.nouser);
				}
			}).fail(function(xhr){
				console.log(xhr);
			});
		}
	});

	// DATE FIELDS
	if ($('#register-date').length) {
		var picker = new Litepicker({
			element: document.getElementById('register-date'),
			format: 'DD/MM/YYYY',
			lang: 'pt-PT',
			dropdowns: {
				minYear: 1900,
				maxYear: null,
				months: true,
				years: true,
			},
			showWeekNumbers: false
		});
	}

	if ($('#customer-birthdate').length) {
		var picker = new Litepicker({
			element: document.getElementById('customer-birthdate'),
			format: 'DD/MM/YYYY',
			lang: 'pt-PT',
			dropdowns: {
				minYear: 1900,
				maxYear: null,
				months: true,
				years: true,
			},
			showWeekNumbers: false
		});
	}

	if ($('#animal-birthdate').length) {
		var picker = new Litepicker({
			element: document.getElementById('animal-birthdate'),
			format: 'DD/MM/YYYY',
			lang: 'pt-PT',
			dropdowns: {
				minYear: 1900,
				maxYear: null,
				months: true,
				years: true,
			},
			showWeekNumbers: false
		});
	}

	// TESTIMONIAL MESSAGE
	$('#testimonial-message').on('submit', function(e) {
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			let form_data = $(this).serializeArray();

			$.ajax({
				type: data.rest.endpoints.testimonial_message.method,
				dataType: 'json',
				url: data.rest.endpoints.testimonial_message.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				$('#testimonial-message').hide();
				$('#testimonial-modal .success-message').show();
			}).fail(function(xhr){
				console.log(xhr);
			});
		}
	});

	// REGISTER & MYBIGODES PROFILE - check user by mail
	$('input.customer-email').on('blur', function(e){
		let form_container = $(this).closest('form');
		let form_status = $('.user-exists-error');
		let form_data = {
			'user' : $(this).val(),
			'id' : $('#user-id').val()
		};

		$.ajax({
			type: data.rest.endpoints.check_user.method,
			dataType: 'json',
			url: data.rest.endpoints.check_user.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			if (results.message == 'user_exists'){
				form_status.html(data.rest.messages.exists);
				form_container.find('input[type="submit"]').prop('disabled', true);
			} else {
				form_status.html('');
				form_container.find('input[type="submit"]').prop('disabled', false);
			}
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	$('input[name="register-email"').on('focus', function(e){
		$('.user-exists-error').empty();
	});

	// REGISTER & MYBIGODES PROFILE & MYBIGODES APPOINTMENT - district, county, parish selection
	$('.register-district').on('change', function(e){
		let district = $(this).val();
		let counties = JSON.parse($('.register-county').attr('data-counties'));

		$('.register-county').empty();
		$.each(counties, function(key, value){
			if (key.includes(district)) {
				let county_entry = '<option value="' + key + '">' + value + '</option>';
				$('.register-county').append(county_entry);
			}
		});

		if ($('.register-county option').length) {
			$('.register-county-container').fadeIn();
		} else {
			$('.register-county-container').fadeOut();
		}

		$('.register-county').trigger('change');
	});

	$('.register-county').on('change', function(e){
		let county = $(this).val().split('-')[1];
		let parishes = JSON.parse($('.register-parish').attr('data-parishes'));

		$('.register-parish').empty();
		$.each(parishes, function(key, value){
			if (key.includes(county)) {
				let parish_entry = '<option value="' + key + '">' + value + '</option>';
				$('.register-parish').append(parish_entry);
			}
		});

		if ($('.register-parish option').length) {
			$('.register-parish-container').fadeIn();
			$('.register-parish').prop('required', true);
		} else {
			$('.register-parish-container').fadeOut();
			$('.register-parish').prop('required', false);
		}

	});

	// REGISTER - submit register
	$('.customer-register').on('submit', function(e){
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			let form_data = $(this).serializeArray();
			let form_status = $(this).find('.form-message');

			$.ajax({
				type: data.rest.endpoints.customer_register.method,
				dataType: 'json',
				url: data.rest.endpoints.customer_register.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				if (results.message == 'success'){
					$('#login-modal .modal-title').html(data.rest.messages.register_success);
					$('#login-modal').foundation('open');
				} else {
					form_status.addClass('error');
					form_status.html(data.rest.messages.error);
				}
			}).fail(function(xhr){
				console.log(xhr);
			});
		}
	});

	// MYBIGODES
	// On load, check if appointment param is present
	if ($('.content.mybigodes').length) {
		let param = getUrlParameter('appointment');

		switch(param) {
			case 'yes':
				$('#mybigodes-schedule-label').trigger('click');
				break;
			case 'new':
				$('#mybigodes-schedule-label').trigger('click');
				$('#schedule3-label').trigger('click');
				break;
		}
	}


	// MYBIGODES PROFILE - update profile
	$('#customer-edit').on('submit', function(e){
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			loadingStatus();
			let form_data = $(this).serializeArray();

			$.ajax({
				type: data.rest.endpoints.customer_update.method,
				dataType: 'json',
				url: data.rest.endpoints.customer_update.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				loadingStatus();
				successModal(data.rest.messages.edit_success);
				updateAppointmentAddress();
			}).fail(function(xhr){
				console.log(xhr);
			});
		}
	});

	// MYBIGODES PROFILE - password change
	$('.password-check').on('blur', function(){
		$('#password-change').parsley();
	});

	$('#password-change').on('submit', function(e){
		e.preventDefault();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			loadingStatus();
			let form_data = $('#password-change').serializeArray();

			$.ajax({
				type: data.rest.endpoints.password_update.method,
				dataType: 'json',
				url: data.rest.endpoints.password_update.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				loadingStatus();
				successModal(data.rest.messages.edit_password_success, true);
			}).fail(function(xhr){
				loadingStatus();
				console.log(xhr);
			});
		}
	});

	// MYBIGODES SCHEDULE - schedule entries
	$('#mybigodes-tabs').on('change.zf.tabs', function() {
		if ($('#mybigodes-schedule:visible').length) {
			$('#schedule1 .schedule-entry').each(function(i, el) {
				let parent_height = $(el).height();
				$(el).find('button').height(parent_height);
			});
		}
	});

	// MYBIGODES SCHEDULE - edit appointment
	$(document).on('click', '.appointment-edit', function(e) {
		let appointment = $(this).parents('.schedule-entry').attr('data-appointment');
		let vet = $(this).parents('.schedule-entry').attr('data-vet');
		console.log(vet);
		let type = $(this).parents('.schedule-entry').attr('data-type');
		console.log(type);
		let animal_photo = $(this).parents('.schedule-entry').attr('data-photo');
		let animal_name = $(this).parents('.schedule-entry').attr('data-name');
		let service = $(this).parents('.schedule-entry').attr('data-service');
		let service_icon = $(this).parents('.schedule-entry').attr('data-service-icon');
		let vet_photo = $(this).parents('.schedule-entry').attr('data-vet-photo');
		let vet_name = $(this).parents('.schedule-entry').attr('data-vet-name');

		$('#appointment-edit-modal .calendar-container').empty();
		$('#appointment-edit-modal #appointment-calendar-date').empty();
		$('#appointment-edit-modal .calendar-container').append($('#mybigodes-new-appointment'));
		$('#mybigodes-new-appointment').attr('data-vet', vet);
		$('#mybigodes-new-appointment #appointment-type').val(type);
		$('#mybigodes-new-appointment').attr('data-update', '1');
		$('#mybigodes-new-appointment .photo-button .photo-button-image[data-vet="0"]').addClass('active');
		$('#edit-appointment-confirm-modal .animal-photo').css('background-image', 'url(' + animal_photo + ')');
		$('#edit-appointment-confirm-modal .animal-name').html(animal_name);
		$('#edit-appointment-confirm-modal .icon-button-image').css('background-image', 'url(' + service_icon + ')');
		$('#edit-appointment-confirm-modal .icon-button-caption').html(service);
		$('#edit-appointment-confirm-modal .photo-button-image').css('background-image', 'url(' + vet_photo + ')');
		$('#edit-appointment-confirm-modal .photo-button-caption').html(vet_name);
		$('#mybigodes-new-appointment .mybigodes-form-step').hide();
		$('#mybigodes-new-appointment #na-step-6').show();
		$('#mybigodes-new-appointment #na-step-6 .prev-step').hide();
		$('#mybigodes-new-appointment #na-step-6 .calendar-vet').empty();
		$('#mybigodes-new-appointment #na-step-6 #appointment-calendar-hours ul').empty();
		$('#mybigodes-new-appointment #calendar-vets .photo-button:not([data-service="' + type + '"])').hide();
		$('#mybigodes-new-appointment .photo-button-image').removeClass('active');
		$('#mybigodes-new-appointment .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
		$('#mybigodes-new-appointment .calendar-vet').html($('#mybigodes-new-appointment #na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
		$('#edit-appointment-confirm-modal #appointment-edit-confirm').attr('data-appointment', appointment);
		$('#appointment-edit-modal').foundation('open');
		startCalendar();
	});

	$('#appointment-edit-confirm').on('click', function(e) {
		let appointment = $(this).attr('data-appointment');
		let date = $('#appointment-date').val();
		let form_data = {
			appointment: appointment,
			date: date
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.edit_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.edit_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			successModal(data.rest.messages.edit_appointment, true);
			reloadWellbeingAppointments();
			reloadAppointments();
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	$('#appointment-edit-modal').on('closed.zf.reveal', function(e) {
		$('.cld-main').remove();
		$('#mybigodes-new-appointment #na-step-6').hide();
		$('#mybigodes-new-appointment #na-step-1').show();
		$('#mybigodes-new-appointment').attr('data-vet', '');
		$('#mybigodes-new-appointment').attr('data-update', 0);
		$('#mybigodes-new-appointment .calendar-vet').html('');
		$('#mybigodes-new-appointment .photo-button .photo-button-image').removeClass('active');
		$('#schedule3').append($('#mybigodes-new-appointment'));
		$('#mybigodes-new-appointment #calendar-vets .photo-button').show();
	});

	// MYBIGODES SCHEDULE - cancel appointment
	$(document).on('click', '#schedule1 .appointment-cancel', function(e) {
		let appointment = $(this).attr('data-appointment');
		let form_data = {
			appointment: appointment
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.get_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.get_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			$('#appointment-cancel-modal .appointment-date').html(results.date.replace(/-/g, '/'));
			$('#appointment-cancel-modal .animal-photo').css('background-image', 'url(' + results.animal_photo + ')');
			$('#appointment-cancel-modal .animal-name').html(results.animal_name);
			$('#appointment-cancel-modal .icon-button-image').css('background-image', 'url(' + results.service_icon + ')');
			$('#appointment-cancel-modal .icon-button-caption').html(results.service_name);
			$('#appointment-cancel-modal .photo-button-image').css('background-image', 'url(' + results.vet_photo + ')');
			$('#appointment-cancel-modal .photo-button-caption').html(results.vet_name);
			$('#appointment-cancel').attr('data-appointment', appointment);
			$('#appointment-cancel-modal').foundation('open');
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	$('#appointment-mantain').on('click', function(e) {
		$('#appointment-cancel-modal').foundation('close');
	});

	$('#appointment-cancel').on('click', function(e) {
		let appointment = $(this).attr('data-appointment');
		let form_data = {
			appointment: appointment,
			referrer: 'schedule'
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.cancel_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.cancel_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			successModal(data.rest.messages.cancel_appointment, true);
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	// MYBIGODES SCHEDULE - schedule wellbeing item
	$(document).on('click', '.wellbeing-schedule', function(e) {
		let appointment = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-appointment');
		let type = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-type');
		let type_label = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-type-label');
		let motive = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-motive');
		let motive_label = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-motive-label');
		let context = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-context');
		let animal = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-animal');
		let animal_name = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-animal-name');
		let day = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-day');
		let month = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-month');
		let year = $(this).closest('.wellbeing-schedule-entry').find('.schedule-entry').attr('data-year');
		let animal_icon = $('#mybigodes-new-appointment .animal-icon[data-animal="' + animal + '"]');
		let service_icon = $('#mybigodes-new-appointment .icon-button[data-type="' + type + '"]');
		const district = $('#mybigodes-new-appointment').attr('data-district');

		$('#wellbeing-create-modal .process-container').append($('#mybigodes-new-appointment'));
		$('#mybigodes-new-appointment #appointment-id').val(appointment);
		$('#mybigodes-new-appointment #appointment-type').val(type);
		$('#mybigodes-new-appointment #appointment-motive').val(motive);
		$('#mybigodes-new-appointment #appointment-context').val(context);
		$('#mybigodes-new-appointment #appointment-animals').val(animal);
		$('#mybigodes-new-appointment').attr('data-day', day);
		$('#mybigodes-new-appointment').attr('data-month', month);
		$('#mybigodes-new-appointment').attr('data-year', year);
		$('#mybigodes-new-appointment').attr('data-wellbeing', 1);

		$('#wellbeing-create-modal .appointment-date').html(animal_name + ' - ' + type_label + ' - ' + motive_label);
		$('#mybigodes-new-appointment .mybigodes-form-step').hide();
		$('#mybigodes-new-appointment #na-step-5').show();
		$('#mybigodes-new-appointment #na-step-5 .prev-step').hide();
		$('#mybigodes-new-appointment #na-step-5 .photo-button').show();
		$('#mybigodes-new-appointment #na-step-5 .photo-button:not([data-service="' + type + '"])').hide();
		$('#mybigodes-new-appointment #na-step-6 .calendar-vet').empty();
		$('#mybigodes-new-appointment #na-step-6 #appointment-calendar-hours ul').empty();
		$('#mybigodes-new-appointment #calendar-vets .photo-button:not([data-service="' + type + '"])').hide();
		$('#mybigodes-new-appointment .photo-button-image').removeClass('active');
		$('#new-appointment-confirm-modal .animal').append($(animal_icon).clone());
		$('#new-appointment-confirm-modal .service').append($(service_icon).clone());

		$('#na-step-5 .photo-button').each(function(index, item) {
			let vet_district = $(item).attr('data-districts');

			if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
				$(this).hide();
			}
		});

		$('#wellbeing-create-modal').foundation('open');
	});

	$('#wellbeing-create-modal').on('closed.zf.reveal', function(e) {
		$('#wellbeing-create-modal .appointment-date').html('');
		$('.cld-main').remove();
		$('#mybigodes-new-appointment .mybigodes-form-step').hide();
		$('#mybigodes-new-appointment #na-step-1').show();
		$('#mybigodes-new-appointment').attr('data-vet', '');
		$('#mybigodes-new-appointment').attr('data-wellbeing', 0);
		$('#mybigodes-new-appointment #na-step-5 .next-step').hide();
		$('#mybigodes-new-appointment .calendar-vet').html('');
		$('#mybigodes-new-appointment .photo-button .photo-button-image').removeClass('active');
		$('#schedule3').append($('#mybigodes-new-appointment'));
		$('#mybigodes-new-appointment #calendar-vets .photo-button').show();
	});

	$('#new-appointment-confirm-modal').on('closed.zf.reveal', function(e) {
		$('#new-appointment-confirm-modal .animal').empty();
		$('#new-appointment-confirm-modal .service').empty();
		$('#new-appointment-confirm-modal .vet').empty();
	});

	// MYBIGODES SCHEDULE & ANIMALS - cancel wellbeing item
	$(document).on('click', '.wellbeing-maintain', function(e) {
		$('#wellbeing-cancel-modal').foundation('close');
	});

	$(document).on('click', '.wellbeing-delete', function(e) {
		console.log('click');
		let appointment = $(this).attr('data-appointment');
		let date = $(this).closest('.schedule-entry').find('.date').text();
		let form_data = {
			appointment: appointment
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.get_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.get_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			$('#wellbeing-cancel-modal .appointment-date').html(date);
			$('#wellbeing-cancel-modal .animal-photo').css('background-image', 'url(' + results.animal_photo + ')');
			$('#wellbeing-cancel-modal .animal-name').html(results.animal_name);
			$('#wellbeing-cancel-modal .icon-button-image').css('background-image', 'url(' + results.service_icon + ')');
			$('#wellbeing-cancel-modal .icon-button-caption').html(results.service_name);
			$('#wellbeing-cancel-modal .photo-button-image').css('background-image', 'url(' + results.vet_photo + ')');
			$('#wellbeing-cancel-modal .photo-button-caption').html(data.rest.messages.no_vet);
			$('#wellbeing-cancel').attr('data-appointment', appointment);
			$('#wellbeing-cancel-modal').foundation('open');
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	$('#wellbeing-cancel').on('click', function(e) {
		let appointment = $(this).attr('data-appointment');
		let customer = $(this).attr('data-customer');
		let form_data = {
			appointment: appointment,
			referrer: 'wellbeing'
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.cancel_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.cancel_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			successModal(data.rest.messages.delete_wellbeing, true);
			reloadWellbeingAppointments();
			reloadAppointments();
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	// MYBIGODES POINTS - show benefits
	$('.show-rewards').on('click', function(e) {
		e.preventDefault();
		$('.form-message').hide();
		$('.points-screen').hide();
		$('#points-rewards').show();
	});

	$('.show-actions').on('click', function(e) {
		e.preventDefault();
		$('.form-message').hide();
		$('.points-screen').hide();
		$('#points-actions').show();
	});

	// MYBIGODES POINTS - show history
	$('.show-points').on('click', function() {
		reloadHistory($('.points-history').attr('data-customer'));
	});

	// MYBIGODES POINTS - redeem codes
	$('#points-redeem').on('submit', function(e){
		e.preventDefault();
		loadingStatus();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			let form_data = $(this).serializeArray();

			$.ajax({
				type: data.rest.endpoints.code_redeem.method,
				dataType: 'json',
				url: data.rest.endpoints.code_redeem.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				loadingStatus();
				if (results.message == 'success') {

					successModal(data.rest.messages.code_success);
					$('.no-points').hide();
					$('#customer-points').html(results.points);
				} else {
					successModal(data.rest.messages.code_error);
				}
				reloadHistory($('.points-history').attr('data-customer'));
			}).fail(function(xhr){
				successModal(data.rest.messages.code_error);
			});
		}
	});

	// MYBIGODES POINTS - referral
	$('input[name="referral-name"]').on('input', function(){
		let name = $(this).val();
		let message = $('textarea[name="referral-message"]').val();
		let friend = message.split(',', 1)[0];

		$('textarea[name="referral-message"]').val($('textarea[name="referral-message"]').val().replace(friend, 'Olá ' + name));
	});

	$('#referral-send').on('submit', function(e){
		e.preventDefault();
		$('textarea[name="referral-message"]').attr('disabled', false);
		let email = $(this).find('input[name="referral-email"]');
		let phone = $(this).find('input[name="referral-phone"]');

		if (!email.val() && !phone.val()) {
			$('textarea[name="referral-message"]').attr('disabled', true);
			successModal(data.rest.messages.referral_contact);
		} else {
			$(this).parsley().validate();

			if ($(this).parsley().isValid()){
				loadingStatus();
				let form_data = $(this).serializeArray();

				$('textarea[name="referral-message"]').attr('disabled', true);
				$.ajax({
					type: data.rest.endpoints.customer_referral.method,
					dataType: 'json',
					url: data.rest.endpoints.customer_referral.url,
					data: form_data,
					beforeSend: function(xhr){
						xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
					}
				}).done(function(results){
					loadingStatus();
					if (results.message == 'success') {
						successModal(data.rest.messages.referral_success);
					} else {
						successModal(data.rest.messages.error);
					}
				}).fail(function(xhr){
					loadingStatus();
					successModal(data.rest.messages.error);
				});
			}
		}
	});

	// MYBIGODES - SCHEDULE
	// new package appointment
	$('.package-schedule').on('click', function(e) {
		let appointment = $(this).closest('.schedule-entry').attr('data-appointment');
		let type_label = $(this).closest('.schedule-entry').attr('data-type-label');
		let type = $(this).closest('.schedule-entry').attr('data-type');
		let context = $(this).closest('.schedule-entry').attr('data-context');

		$('#mybigodes-new-appointment #appointment-id').val(appointment);
		$('#mybigodes-new-appointment #appointment-type').val(type);
		$('#mybigodes-new-appointment #appointment-context').val(context);
		$('#mybigodes-new-appointment').attr('appointment-package', 1);
		$('#mybigodes-new-appointment .package-title').append(type_label);
		$('#mybigodes-new-appointment .package-title').show();

		$('#na-step-5 .photo-button').each(function(index, item) {
			let vet_district = $(item).attr('data-districts');

			if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
				$(this).hide();
			}
		});

		$('a[href="#schedule3"').trigger('click');
	});

	// new appointment form
	$('#schedule3-label').on('click', function(e) {
		appointmentReset();
		contextMessage(data.rest.messages.na_where_title, data.rest.messages.na_where_text);
	});

	$(document).on('click', '#mybigodes-new-appointment .button-row input[type="button"]', function(e){
		let title, text, step;

		$(this).closest('.mybigodes-form-step').slideUp();
		if ($(this).hasClass('next-step')) {
			$(this).closest('.mybigodes-form-step').next().slideDown();
			step = $(this).closest('.mybigodes-form-step').next().attr('id');
		} else {
			$(this).closest('.mybigodes-form-step').prev().slideDown();
			step = $(this).closest('.mybigodes-form-step').prev().attr('id');
		}

		switch (step) {
			case 'na-step-1':
				title = data.rest.messages.na_where_title;
				text = data.rest.messages.na_where_text;
				break;
			case 'na-step-2':
				title = data.rest.messages.na_who_title;
				text = data.rest.messages.na_who_text;
				break;
			case 'na-step-3':
				title = data.rest.messages.na_what_title;
				text = data.rest.messages.na_what_text;
				break;
			case 'na-step-4':
				title = data.rest.messages.na_what_title;
				text = data.rest.messages.na_what_specify_text;
				break;
			case 'na-step-5':
				title = data.rest.messages.na_dr_title;
				text = data.rest.messages.na_dr_text;
				break;
			case 'na-step-6':
				title = data.rest.messages.na_when_title;
				text = data.rest.messages.na_when_text;
				break;
		}

		contextMessage(title, text);
	});

	$(document).on('click', '#na-step-2 .animal-icon', function(e) {
		$(this).find('.animal-photo').toggleClass('active');
		$(this).find('.animal-photo');

		if ($('#na-step-2 .animal-photo.active').length) {
			$('#na-step-2 .next-step').show();

			if ($('#mybigodes-new-appointment').attr('appointment-package') == 1) {
				$('#na-step-2 .next-step').trigger('click');
			}
		} else {
			$('#na-step-2 .next-step').hide();
		}

		if ($('#na-step-2 .animal-photo.active').length > 2) {
			$('#na-step-2 .animals-warning').fadeIn();
		} else {
			$('#na-step-2 .animals-warning').fadeOut();
		}
	});

	// set appointment animals
	$(document).on('click', '#na-step-2 .next-step', function(e) {
		let animals = [];
		$('#new-appointment-confirm-modal .appointment-data .animal').empty();
		$('#na-step-2 .animal-photo.active').each(function(i, el) {
			let animal_id = $(this).parent().attr('data-animal');
			animals.push(animal_id);

			let icon = $(this).parent();
			$('#new-appointment-confirm-modal .appointment-data .animal').append($(icon).clone());
		});
		$('#appointment-animals').val(animals);

		if ($('#mybigodes-new-appointment').attr('appointment-package') == 1) {
			$('#na-step-3 .icon-button[data-type="' + $('#appointment-type').val() + '"]').trigger('click');
		}
	});

	$(document).on('click', '#na-step-3 .icon-button', function(e) {
		$('#appointment-type').val($(this).attr('data-type'));
		$('#na-step-5 .photo-button').hide();
		$('#na-step-6 .photo-button').hide();
		$('#na-step-5 .photo-button[data-service="' + $(this).attr('data-type') + '"]').show();
		$('#na-step-6 .photo-button[data-service="' + $(this).attr('data-type') + '"]').show();
		$('#na-step-4 .type-icon').empty();
		$('#na-step-3 .icon-button-image').removeClass('active');
		$(this).clone().appendTo('#na-step-4 .type-icon');
		$(this).find('.icon-button-image').addClass('active');

		if ($('.icon-button-image.active').length) {
			$('#na-step-4 .motive-list').hide();
			$('#na-step-4 #' + $(this).attr('data-type') + '-motive').show();
			$('#na-step-3 .next-step').show();
		} else {
			$('#na-step-3 .next-step').hide();
		}

		if ($('#mybigodes-new-appointment').attr('appointment-package') == 1) {
			$('#na-step-3 .next-step').trigger('click');
		}
	});

	$(document).on('click', '#na-step-3 .next-step', function(e) {
		$('#new-appointment-confirm-modal .appointment-data .service').empty();
		$('#new-appointment-confirm-modal .appointment-data .animal-icon').each(function(i, el) {
			$('#na-step-3 .icon-button-image.active').parent().clone().appendTo('#new-appointment-confirm-modal .appointment-data .service');
		});
		if ($('#mybigodes-new-appointment').attr('appointment-package') == 1) {
			$('#na-step-4 .prev-step').hide();
		}
	});

	$('#na-step-4 .motive-list button').on('click', function(e) {
		e.preventDefault();
		$('#na-step-4 .motive-list .list').removeClass('active');
		$(this).addClass('active');
		$('#appointment-motive').val($(this).attr('data-customer-motive'));
		$('.appointment-description-container').fadeIn();
		$('#na-step-4 .next-step').show();
	});

	$(document).on('click', '#na-step-4 .prev-step', function(e) {
		$('.appointment-description-container').fadeOut();
	});

	$(document).on('click', '#na-step-4 .next-step', function(e) {
		const district = $('#mybigodes-new-appointment').attr('data-district');

		$('#na-step-5 .photo-button').each(function() {
			let vet_district = $(this).attr('data-districts');

			if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
				$(this).hide();
			}
		});
	});

	$('#na-step-5 .photo-button').on('click', function(e) {
		let vet = $(this).attr('data-vet');
		$('#na-step-5 .photo-button-image').removeClass('active');
		$(this).find('.photo-button-image').addClass('active');
		$('#na-step-6 .photo-button .photo-button-image').removeClass('active');
		$('#na-step-6 .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
		$('#na-step-6 .calendar-vet').html($('#na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
		$('#mybigodes-new-appointment').attr('data-vet', vet);
		$('#na-step-5 .next-step').show();
	});

	$('#na-step-5 .next-step').on('click', function(e) {
		let date = $('#mybigodes-new-appointment').attr('data-my');
		let vet = $('#mybigodes-new-appointment').attr('data-vet');
		const district = $('#mybigodes-new-appointment').attr('data-district');

		$('#na-step-6 .photo-button').each(function() {
			let vet_district = $(this).attr('data-districts');

			if (vet_district != 'Todos' && vet_district.indexOf(district) == -1) {
				$(this).hide();
			}
		});

		updateVet();
		startCalendar();
	});

	$('#na-step-6 .prev-step').on('click', function(e) {
		$('#appointment-calendar-date').empty();
	});

	$('#na-step-6 .photo-button').on('click', function(e) {
		let vet = $(this).attr('data-vet');
		let date = $('#mybigodes-new-appointment').attr('data-my');
		$('.photo-button .photo-button-image').removeClass('active');
		$(this).find('.photo-button-image').addClass('active');
		$('#na-step-5 .photo-button[data-vet="' + vet + '"] .photo-button-image').addClass('active');
		$('#mybigodes-new-appointment').attr('data-vet', vet);
		$('#na-step-6 .calendar-vet').html($('#na-step-6 .photo-button[data-vet="' + vet + '"]').attr('data-name'));
		updateVet();
		updateCalendar();
	});

	$(document).on('click', '.cld-nav', function(e) {
		let vet = $(this).attr('data-vet');
		let date = $('#mybigodes-new-appointment').attr('data-my');
		updateCalendar();
	});

	$(document).on('click', '#na-step-6 .cld-day.active', function(e) {
		let template = jQuery('#appointment-hour-slots').html();
		let slots = JSON.parse(jQuery(this).attr('data-schedule'));
		let day = $(this).text();
		let monthyear = $('.cld-datetime .today').text();
		let date = $('#appointment-calendar-info').attr('data-date');
		if (day < 10) { day = '0' + day; }
		$('#na-step-6 .cld-day.active .cld-number').removeClass('selected');
		$(this).find('.cld-number').addClass('selected');
		$('#na-step-6 .calendar-date').html(day + '-' + monthyear.replace(' ', '-'));
		$('#appointment-calendar-hours ul').empty();
		$('#appointment-calendar-hours').attr('data-date', day + '-' + date);

		$.each(slots.hours, function(slot){
			let start_hour = slot + ':00';
			let end = parseInt(slot.substring(0, 2)) + 1;

			if ($('#appointment-type').val() == 'grooming') {
				end = parseInt(slot.substring(0, 2)) + 2;
			}

			let end_hour = end + ':00';
			let item = jQuery(template).clone();

			item.attr('data-hour', start_hour);
			item.html(start_hour + ' - ' + end_hour);
			if ($('#appointment-type').val() != 'grooming') {
				$('#appointment-calendar-hours ul').append(item);
			} else {
				if (slot % 2 === 0) {
					$('#appointment-calendar-hours ul').append(item);
				}
			}
		});
	});

	$(document).on('click', '#appointment-calendar-hours li', function(e) {
		let fulldate = $('#appointment-calendar-info .calendar-date').text().replace('-', ' de ');
		let date = $('#appointment-calendar-hours').attr('data-date');
		let weekday = new Date($('#appointment-calendar-hours').attr('data-date'));
		let slot = $(this).text().replace('-', ' às ');
		$('#appointment-calendar-hours li').removeClass('active');
		$(this).addClass('active');
		$('#appointment-date').val(date + ' ' + $(this).attr('data-hour'));
		if ($('#mybigodes-new-appointment').attr('data-update') == 1) {
			$('#edit-appointment-confirm-modal .appointment-date').text(date + ' ' + $(this).attr('data-hour'));
			$('#edit-appointment-confirm-modal').foundation('open');
		} else {
			$('#new-appointment-confirm-modal .appointment-date').text(date + ' ' + $(this).attr('data-hour'));
			$('#new-appointment-confirm-modal').foundation('open');
		}
	});

	$(document).on('click', '#new-appointment-confirm-modal #new-appointment-change', function(e) {
		$('#mybigodes-new-appointment .cld-number').removeClass('selected');
		$('#mybigodes-new-appointment .calendar-date').empty();
		$('#mybigodes-new-appointment #appointment-calendar-hours li').remove();
		$('#new-appointment-confirm-modal').foundation('close');
	});

	$(document).on('click', '#new-appointment-confirm-modal #new-appointment-confirm', function(e) {
		$('#new-appointment').submit();
	});

	$('#new-appointment').on('submit', function(e) {
		e.preventDefault();
		loadingStatus();
		let form_data = $(this).serializeArray();

		$.ajax({
			type: data.rest.endpoints.new_appointment.method,
			dataType: 'json',
			url: data.rest.endpoints.new_appointment.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			let customer = $('#new-appointment #appointment-customer').val();

			loadingStatus();
			successModal(data.rest.messages.new_appointment, true);
		}).fail(function(xhr){
			console.log(xhr);
		});
	});

	$('#type-sitting').on('click', function(e) {
		$('#sitting-modal').foundation('open');
	});

	$('#sitting-send').on('submit', function(e){
		e.preventDefault();
		let email = $(this).find('input[name="sitting-email"]');
		let phone = $(this).find('input[name="sitting-phone"]');

		if (!email.val() && !phone.val()) {
			successModal(data.rest.messages.referral_contact);
		} else {
			$(this).parsley().validate();

			if ($(this).parsley().isValid()){
				loadingStatus();
				let form_data = $(this).serializeArray();

				$.ajax({
					type: data.rest.endpoints.sitting_request.method,
					dataType: 'json',
					url: data.rest.endpoints.sitting_request.url,
					data: form_data,
					beforeSend: function(xhr){
						xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
					}
				}).done(function(results){
					loadingStatus();
					if (results.message == 'success') {
						successModal(data.rest.messages.sitting_success, true);
					} else {
						successModal(data.rest.messages.error)
					}
				}).fail(function(xhr){
					loadingStatus();
					successModal(data.rest.messages.error)
				});
			}
		}
	});

	// MYBIGODES ANIMALS
	// check if tab change
	$('#mybigodes-animals-tabs').on('change.zf.tabs', function() {
		if ($('#animals2:visible').length) {
			$('#animals2 .schedule-entry').each(function(i, el) {
				let parent_height = $(el).height();
				$(el).find('button').height(parent_height);
			});
		}
	});

	// get animal
	$(document).on('click', '#mybigodes-animals .animal-icon', function(e) {
		let animal = $(this).attr('data-animal');
		$('.animal-photo').removeClass('active');
		$(this).find('.animal-photo').addClass('active');
		$('#animal-file .grid-body .schedule-entry').remove();
		$('#animal-file .grid-body .schedule-border').remove();
		$('#animal-file .grid-body .schedule-entry').remove();

		if (animal != 0) {
			loadingStatus();
			$.ajax({
				type: data.rest.endpoints.get_animal.method,
				dataType: 'json',
				url: data.rest.endpoints.get_animal.url,
				data: {'animal': animal},
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				let history_template = jQuery('#animals-history-template').html();
				let exams_template = jQuery('#animals-exams-template').html();
				let wellbeing_template = jQuery('#animals-wellbeing-template').html();

				$('.animal-grid').slideUp();
				$('.picture-wrap').show();
				$('#animal-file .picture-box').css('background-image', 'url(' + results.animal.photo + ')');
				$('#picture-animal').val(results.animal.id);
				$('#animal-file input[name="animal-id"]').val(results.animal.id);
				$('#animal-file input[name="animal-name"]').val(results.animal.name);
				$('#animal-file select[name="animal-type"] option[value="' + results.animal.type + '"]').prop('selected', true);
				$('#animal-file select[name="animal-sex"] option[value="' + results.animal.sex + '"]').prop('selected', true);
				$('#animal-file input[name="animal-race"]').val(results.animal.race);
				$('#animal-file input[name="animal-date"]').val(results.animal.date);
				$('#animal-file input[name="animal-weight"]').val(results.animal.weight);
				$('#animal-file input[name="animal-chip"]').val(results.animal.chip);
				$('#animal-delete').attr('data-animal', results.animal.id);

				$.each(results.history, function(index, obj) {
					let item = $(history_template).clone();

					$('#animals-appointment-detail .appointment-detail-content').empty();
					$(item).find('.status').addClass(obj.status_class);
					$(item).find('.type').html(obj.type);
					$(item).find('.date').html(obj.date.replace(/-/g, '/'));
					$(item).find('.time').html(obj.time);
					$(item).find('.motive').html(obj.motive);
					$(item).find('.vet').html(obj.vet);
					$(item).find('.status_class').addClass(obj.status_class);
					$(item).find('.status_class').html(obj.status);
					$(item).find('.appointment-detail-open').attr('data-animal', obj.animal);
					$(item).find('.appointment-detail-open').attr('data-type', obj.type);
					$(item).find('.appointment-detail-open').attr('data-motive', obj.motive);
					$(item).find('.appointment-detail-open').attr('data-vet', obj.vet);
					$(item).find('.appointment-detail-open').attr('data-date', obj.date.replace(/-/g, '/'));
					$(item).find('.appointment-detail-open').attr('data-notes', obj.anamnese);
					$(item).find('.appointment-detail-open').attr('data-therapy', obj.therapy);

					$('#animals2 .grid-body').append(item);
				});

				$.each(results.exams, function(index, obj) {
					let item = $(exams_template).clone();
					$(item).find('.description').html(obj.description);
					$(item).find('.date').html(obj.date.replace(/-/g, '/'));
					$(item).find('.download').text(data.rest.messages.download);
					$(item).find('.download').attr('href', obj.file);
					$('#animals3 .grid-body').append(item);
				});

				$.each(results.wellbeing, function(index, obj) {
					let item = jQuery(wellbeing_template).clone();

					$(item).find('.type_label').html(obj.type_label);
					$(item).find('.motive_label').html(obj.motive_label);
					$(item).find('.date').text(obj.date.replace(/-/g, '/'));
					$(item).find('.actions .appointment-edit').attr('data-appointment', obj.id);
					$(item).find('.wellbeing-delete').attr('data-appointment', obj.appointment);
					$('#animals4 .grid-body').append(item);

					$('#animals4 .schedule-entry:last').attr('data-animal', obj.animal);
					$('#animals4 .schedule-entry:last').attr('data-animal-name', obj.animal_name);
					$('#animals4 .schedule-entry:last').attr('data-appointment', obj.appointment);
					$('#animals4 .schedule-entry:last').attr('data-type', obj.type);
					$('#animals4 .schedule-entry:last').attr('data-type-label', obj.type_label);
					$('#animals4 .schedule-entry:last').attr('data-motive', obj.motive);
					$('#animals4 .schedule-entry:last').attr('data-motive-label', obj.motive_label);
					$('#animals4 .schedule-entry:last').attr('data-context', obj.context);
					$('#animals4 .schedule-entry:last').attr('data-date', obj.date.replace(/-/g, '/'));
					$('#animals4 .schedule-entry:last').attr('data-day', obj.day);
					$('#animals4 .schedule-entry:last').attr('data-month', obj.month);
					$('#animals4 .schedule-entry:last').attr('data-year', obj.year);
				});
				loadingStatus();

				$('#animal-file').slideDown();
				slideTo('#animal-file');
			}).fail(function(xhr){
				loadingStatus();
				console.log(xhr);
			});
		} else {
			$('.picture-wrap').hide();
			$('#animal-file .picture-box').css('background-image', 'url(/wp-content/themes/drbigodes/assets/images/icon-animal.svg)');
			$('#animal-file input[name="animal-id"]').val(0);
			$('#animal-file input[type="text"]').val('');
			$('#animal-file select option:selected').removeAttr('selected');
			$('#animal-file').slideDown();
			slideTo('#animal-file');
		}
	});

	// appointment history details
	$(document).on('click', '.appointment-detail-open', function(){
		let data = $(this);
		let animal = data.attr('data-animal');
		let type = data.attr('data-type');
		let motive = data.attr('data-motive');
		let vet = data.attr('data-vet');
		let date = data.attr('data-date');
		let notes = data.attr('data-notes');
		let therapy = data.attr('data-therapy');

		$('#animals-appointment-detail .appointment-animal').text(animal);
		$('#animals-appointment-detail .appointment-type').text(type);
		$('#animals-appointment-detail .appointment-motive').text(motive);
		$('#animals-appointment-detail .appointment-vet').text(vet);
		$('#animals-appointment-detail .appointment-date').text(date);
		$('#animals-appointment-detail .appointment-notes').text(notes);
		$('#animals-appointment-detail .appointment-therapy').text(therapy);
		$('#animals-appointment-detail').foundation('open');
	});

	// update animal
	$('#animal-data-edit').on('submit', function(e) {
		e.preventDefault();
		loadingStatus();
		$(this).parsley().validate();

		if ($(this).parsley().isValid()){
			let form_data = $(this).serializeArray();

			$.ajax({
				type: data.rest.endpoints.animal_update.method,
				dataType: 'json',
				url: data.rest.endpoints.animal_update.url,
				data: form_data,
				beforeSend: function(xhr){
					xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
				}
			}).done(function(results){
				if (results.message == 'success') {
					if (results.status == 'edit') {
						successModal(data.rest.messages.animal_edit_success, true);
					} else if (results.status == 'new') {
						successModal(data.rest.messages.animal_create_success, true);
					}
				} else {
					successModal(data.rest.messages.error);
				}
				loadingStatus();
				slideTo('#mybigodes');
			}).fail(function(xhr){
				successModal(data.rest.messages.error);
			});
		}
	});

	// upload photo
	$('#picture-input').on("change", function() {
		let file = this.files[0];
		if (file.size > 1000000) {
			$(this).val('');
			successModal(data.rest.messages.file_size);
		} else {
			$("#picture-form").submit();
		}
	});

	$('#picture-form').on('submit', function(e) {
		e.preventDefault();
		loadingStatus();
		let form_data = new FormData();
		let animal = $('#picture-animal').val();
		form_data.append('picture-animal', animal);
		form_data.append('picture-input', $('#picture-input')[0].files[0]);

		$.ajax({
			type: data.rest.endpoints.animal_photo.method,
			url: data.rest.endpoints.animal_photo.url,
			contentType: false,
			processData:false,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			if (results.message == 'success') {
				$('.picture-box').css('background-image', 'url(' + results.photo + ')');
				$('.animal-profile .animal-icon[data-animal="' + animal + '"] .animal-photo').css('background-image', 'url(' + results.photo + ')');
				successModal(data.rest.messages.photo_success);
			} else {
				successModal(data.rest.messages.error);
			}
		}).fail(function(xhr){
			loadingStatus();
			successModal(data.rest.messages.error);
		});
	});

	//delete animal
	$('#animal-delete').on('click', function(e) {
		e.preventDefault();
		let animal = $(this).attr('data-animal');
		let photo = $('.picture-box').css('background-image');
		let name = $('input[name="animal-name"]').val();

		$('#animal-delete-modal .animal-photo').css('background-image', photo);
		$('#animal-delete-modal .animal-name').html(name);
		$('#animal-delete-modal #animal-delete-confirm').attr('data-animal', animal);
		$('#animal-delete-modal').foundation('open');
	});

	$('#animal-mantain').on('click', function(e) {
		$('#animal-delete-modal').foundation('close');
	});

	$('#animal-delete-confirm').on('click', function(e) {
		let animal = $(this).attr('data-animal');
		let form_data = {
			animal: animal
		};
		loadingStatus();

		$.ajax({
			type: data.rest.endpoints.delete_animal.method,
			dataType: 'json',
			url: data.rest.endpoints.delete_animal.url,
			data: form_data,
			beforeSend: function(xhr){
				xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
			}
		}).done(function(results){
			loadingStatus();
			successModal(data.rest.messages.animal_delete);
		}).fail(function(xhr){
			console.log(xhr);
		});
	});
});


// FUNCTIONS
// GLOBAL
// Form messages
function formMessage(form, status, message) {
	let message_box = form.find('.form-message');
	message_box.addClass(status);
	message_box.empty();
	message_box.html(message);
	message_box.show();
}

// Context messages
function contextMessage(title, text) {
	jQuery('.mybigodes-tips h4').html(title);
	jQuery('.mybigodes-tips p').html(text);
}

jQuery('.tabs-title a').on('click', function() {
	contextMessage('', '');
});

jQuery('#schedule2-label').on('click', function() {
	contextMessage(data.messages.wellbeing_title, data.messages.wellbeling_text);
});

// Success modal messages
function successModal(content, reload) {
	jQuery('#success-modal').foundation('open');
	jQuery('#success-modal .success-message p').html(content);

	if (reload === true) {
		jQuery('#success-modal').on('closed.zf.reveal', function(e) {
			window.location.href = '//' + window.location.host + '/mybigodes?appointment=yes';
		});
	}
}

// Loading status
function loadingStatus() {
	jQuery('#loading-overlay').css('height', '100%');
	jQuery('#loading-overlay').toggleClass('active');
	if (jQuery('#loading-overlay').hasClass('active')) {
		vivus = new Vivus('icon-loading', { duration: 2000 }, null);
	} else {
		vivus.destroy();
	}
}

// REGISTER
//reset form
function resetRegisterForm() {
	jQuery('#register-modal #register-first').show();
	jQuery('#register-modal #register-last').hide();
	jQuery('.form-navigation .next').show();
	jQuery('.form-navigation [type=submit]').hide();
}

//main control
function registerModalControls() {
	var $sections = jQuery('.form-section');

	function navigateTo(index) {
		jQuery('#register-first').hide();
		jQuery('#register-last').slideDown();

		jQuery('.form-navigation .next').hide();
		jQuery('.form-navigation [type=submit]').show();
	}

	jQuery('.form-navigation .next').on('click', function() {
		console.log('cllick!');
		jQuery('.customer-register').parsley().whenValidate({
			group: 'block-0'
		}).done(function() {
			navigateTo(1);
		});
	});

	$sections.each(function(index, section) {
		jQuery(section).find(':input').attr('data-parsley-group', 'block-' + index);
	});

	$sections.eq(0).addClass('current');
}

// MYBIGODES
// POINTS
// Reload points history
function reloadHistory(customer) {
	jQuery('.points-screen').hide();
	jQuery('#points-history').show();
	jQuery('#points-history .points-entry').remove();
	let template = jQuery('#points-history-template').html();

	jQuery.ajax({
		type: data.rest.endpoints.points_history.method,
		dataType: 'json',
		url: data.rest.endpoints.points_history.url,
		data: 'customer=' + customer,
		beforeSend: function(xhr){
			xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
		}
	}).done(function(results){
		jQuery.each(results, function(index, obj) {
			let item = jQuery(template).clone();
			jQuery(item).find('.event').html(obj.event);
			jQuery(item).find('.date').html(obj.date.replace(/-/g, '/'));
			jQuery(item).find('.points').html(obj.points);
			if (obj.points.includes('-')) {
				jQuery(item).find('.points').addClass('secondary');
			}

			jQuery('.points-history').append(item);
		});
	}).fail(function(xhr){
		console.log(xhr);
	});
}

// APPOINTMENTS
function startCalendar() {
	let days = jQuery(this).attr('data-week');
	let settings = {
		Color: '#662D91',
		LinkColor: '#333',
		NavShow: true,
		NavVertical: false,
		DateTimeShow: true,
		DateTimeFormat: 'mmm, yyyy',
		DatetimeLocation: '',
		EventClick: 'getSlots',
		EventTargetWholeDay: false,
		DisabledDays: days,
		ModelChange: data
	}

	var calendar = caleandar(document.getElementById('appointment-calendar-date'));
	updateCalendar();
}

function getCalendarData(date, vet) {
	let form_data = {
		date: date,
		vet: vet,
		type: jQuery('#appointment-type').val()
	};

	loadingStatus();
	jQuery.ajax({
		type: data.rest.endpoints.calendar.method,
		dataType: 'json',
		url: data.rest.endpoints.calendar.url,
		data: form_data,
		beforeSend: function(xhr){
			xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
		}
	}).done(function(results){
		loadingStatus();

		jQuery.each(results, function(i, el) {
			let day = jQuery('.cld-day[data-monthday="' + i + '"]');
			jQuery(day).addClass('active');
			jQuery(day).attr('data-schedule', JSON.stringify(el));
		});
	}).fail(function(xhr){
		loadingStatus();
	});
}

function updateCalendar() {
	let vet = jQuery('#mybigodes-new-appointment').attr('data-vet');
	let fulldate = jQuery('#appointment-calendar-date .cld-datetime .today').html().split(' ');
	let month = jQuery.inArray(fulldate[0], months) + 1;
	if (month < 10) {
		month = '0' + month;
	}
	let year = fulldate[1];
	let date = month + year;

	jQuery('#appointment-vet').val(vet);
	jQuery('#appointment-calendar-info').attr('data-date', month + '-' + year);
	jQuery('#mybigodes-new-appointment').attr('data-my', date);
	jQuery('.cld-day').removeClass('active');
	jQuery('.cld-day').attr('data-schedule', '');
	getCalendarData(date, vet);
}

function updateVet() {
	jQuery('#new-appointment-confirm-modal .appointment-data .vet').empty();
	jQuery('#new-appointment-confirm-modal .appointment-data .animal-icon').each(function(i, el) {
		jQuery('#na-step-5 .photo-button-image.active').parent().clone().appendTo('#new-appointment-confirm-modal .appointment-data .vet');
	});
}

function appointmentCleanup() {
	jQuery('#mybigodes-new-appointment .cld-number').removeClass('selected');
	jQuery('#mybigodes-new-appointment .calendar-date').empty();
	jQuery('#mybigodes-new-appointment #appointment-calendar-hours li').remove();
	jQuery('#mybigodes-new-appointment .cld-main').remove();
	jQuery('#new-appointment-confirm-modal .animal').empty();
	jQuery('#new-appointment-confirm-modal .service').empty();
	jQuery('#new-appointment-confirm-modal .vet').empty();
	jQuery('#new-appointment-confirm-modal .animal').empty();
	jQuery('#new-appointment-confirm-modal .service').empty();
	jQuery('#new-appointment-confirm-modal .vet').empty();
}

function appointmentReset() {
	appointmentCleanup();
	jQuery('.mybigodes-form-step .photo-button-image').removeClass('active');
	jQuery('.mybigodes-form-step .icon-button-image').removeClass('active');
	jQuery('.mybigodes-form-step .list').removeClass('active');
	jQuery('.mybigodes-form-step .animal-photo').removeClass('active');
	jQuery('.mybigodes-form-step .icon-button').removeClass('active');
	jQuery('.mybigodes-form-step .next-step').hide();
	jQuery('.mybigodes-form-step').hide();
	jQuery('#na-step-1').show();
	jQuery('#na-step-1 .next-step').show();
}

function reloadAppointments() {
	let customer = jQuery('.mybigodes').attr('data-customer');
	let template = jQuery('#schedule-appointments-template').html();
	let form_data = {
		customer: customer
	};

	jQuery.ajax({
		type: data.rest.endpoints.get_appointments.method,
		dataType: 'json',
		url: data.rest.endpoints.get_appointments.url,
		data: form_data,
		beforeSend: function(xhr){
			xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
		}
	}).done(function(results){
		jQuery('#schedule1 .grid-body > .schedule-entry').remove();
		jQuery('#schedule1 .grid-body > .schedule-border').remove();
		jQuery('#schedule1 .schedule-empty').remove();
		jQuery.each(results, function(index, obj) {
			let item = jQuery(template).clone();

			jQuery(item).first().attr('data-vet', obj.vet_id);
			jQuery(item).first().attr('data-type', obj.type);
			jQuery(item).first().attr('data-month', obj.month);
			jQuery(item).first().attr('data-photo', obj.vet_photo);
			jQuery(item).first().attr('data-name', obj.animal);
			jQuery(item).first().attr('data-service', obj.type_name);
			jQuery(item).first().attr('data-service-icon', obj.type_icon);
			jQuery(item).first().attr('data-vet-photo', obj.vet_photo);
			jQuery(item).first().attr('data-vet-name', obj.vet);
			jQuery(item).first().attr('data-appointment', obj.id);
			jQuery(item).first().addClass(obj.status_class);
			jQuery(item).find('div.status').addClass(obj.type);
			jQuery(item).find('.animal').text(obj.animal);
			jQuery(item).find('.date').text(obj.date);
			jQuery(item).find('.hour').text(obj.hour);
			jQuery(item).find('.type').text(obj.type_name);
			jQuery(item).find('.motive').text(obj.motive);
			jQuery(item).find('.vet').text(obj.vet);
			jQuery(item).find('.button-holder.status').text(obj.status);
			jQuery(item).find('.button-holder button').attr('data-appointment', obj.id);
			jQuery(item).find('.cell:last-child').addClass(obj.status_class);
			jQuery(item).find('span.status').text(obj.status);

			jQuery('#schedule1 .grid-body').append(item);
		});

		jQuery('#schedule1-label').trigger('click');
	}).fail(function(xhr){
		loadingStatus();
	});
}

function reloadWellbeingAppointments() {
	let customer = jQuery('.mybigodes').attr('data-customer');
	let template = jQuery('#schedule-wellbeing-template').html();
	let form_data = {
		customer: customer
	};

	jQuery.ajax({
		type: data.rest.endpoints.get_wellbeing_appointments.method,
		dataType: 'json',
		url: data.rest.endpoints.get_wellbeing_appointments.url,
		data: form_data,
		beforeSend: function(xhr){
			xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
		}
	}).done(function(results){
		jQuery('#schedule2 .grid-body > .schedule-entry').remove();
		jQuery('#schedule2 .grid-body > .schedule-border').remove();
		jQuery('#schedule2 .schedule-empty').remove();
		jQuery.each(results, function(index, obj) {
			let item = jQuery(template).clone();

			jQuery(item).first().attr('data-animal', obj.animal_id);
			jQuery(item).first().attr('data-animal-name', obj.animal_name);
			jQuery(item).first().attr('data-appointment', obj.appointment);
			jQuery(item).first().attr('data-type', obj.type);
			jQuery(item).first().attr('data-motive', obj.motive);
			jQuery(item).first().attr('data-motive-label', obj.motive_label);
			jQuery(item).first().attr('data-day', obj.day);
			jQuery(item).first().attr('data-month', obj.month);
			jQuery(item).first().attr('data-year', obj.year);
			jQuery(item).first().addClass(obj.status);
			jQuery(item).find('div.status').addClass(obj.type);
			jQuery(item).find('.animal').text(obj.animal_name);
			jQuery(item).find('.date').text(obj.date);
			jQuery(item).find('.type').text(obj.type_label);
			jQuery(item).find('.motive').text(obj.motive_label);
			jQuery(item).find('.vet').text(obj.vet);
			jQuery(item).find('.button-holder button').attr('data-appointment', obj.appointment);
			jQuery('#schedule2 .grid-body').append(item);
		});

	}).fail(function(xhr){
		loadingStatus();
	});
}

function updateAppointmentAddress() {
	let district = jQuery('#customer-district').val();
	let county = jQuery('#customer-county').val();
	let parish = jQuery('#customer-parish').val();

	jQuery('#appointment-address').val(jQuery('#customer-address').val());
	jQuery('#appointment-zip').val(jQuery('#customer-zip').val());
	jQuery('#appointment-district').val(district);
	jQuery('#appointment-county').val(county);
	jQuery('#appointment-parish').val(parish);
	jQuery('#appointment-locality').val(jQuery('#customer-locality').val());
	jQuery('#appointment-phone').val(jQuery('#customer-phone').val());
}

// ANIMALS
// reload animal list
function reloadAnimals(customer) {
	jQuery.ajax({
		type: data.rest.endpoints.get_animals.method,
		dataType: 'json',
		url: data.rest.endpoints.get_animals.url,
		data: 'customer=' + customer,
		beforeSend: function(xhr){
			xhr.setRequestHeader('X-WP-Nonce', data.rest.nonce);
		}
	}).done(function(results){
		let template = jQuery('#animals-profile-template').html();
		jQuery('.animal-profile .animal-icon:not(.animal-new').remove();

		jQuery.each(results, function(index, obj) {
			let item = jQuery(template).clone();
			if (obj.data.animal.photo === 'undefined') {
			 var photo = '/wp-content/themes/drbigodes/assets/images/icon-animal.svg';
			} else {
				var photo = obj.data.animal.photo;
			}

			jQuery(item).attr('data-animal', obj.data.animal.id);
			jQuery(item).find('.animal-photo').css('background-image', 'url(' + photo + ')');
			jQuery(item).find('.animal-name').html(obj.data.animal.name);
			jQuery('.animal-profile').append(item);
		});
	}).fail(function(xhr){
		console.log(xhr);
	});
}

// SUPPORT
// Substring search polyfill
if (!String.prototype.includes) {
	String.prototype.includes = function(search, start) {
		'use strict';

	if (search instanceof RegExp) {
		throw TypeError('first argument must not be a RegExp');
	}
	if (start === undefined) { start = 0; }
		return this.indexOf(search, start) !== -1;
	};
}

// Smooth scrolling
function slideTo(element) {
	jQuery('html, body').animate({
		scrollTop: jQuery(element).offset().top
	}, 500);
}

// Clean appointment package title when leaving screen
jQuery('.tabs-title a').on('click', function(e) {
	jQuery('.package-title').hide();
});

// Check for query string params
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};